import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';
import { AppRoutes } from '../../App/routes';

export const sessionsRoot = 'sessions';
export const devicesQuery = '?tab=devices';

export const sessionsOverviewRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${sessionsRoot}`;

export const sessionsDevicesTabRoute = `${sessionsOverviewRoute}${devicesQuery}`;
